import { NavLink } from "react-router-dom";
import { Sparkles } from "lucide-react";
import { cn } from "../../../../utils/utils";
import {
  REPORT_GROUPS,
  TOP_LEVEL_ITEM,
  getItemsInGroup,
} from "../../config/reportLibrary";

const Item = ({ item, onNavigate }) => {
  const Icon = item.icon;
  const isSoon = item.status === "soon";

  if (isSoon) {
    return (
      <div
        className="flex items-center gap-2.5 px-3 py-2 rounded-md text-sm text-gray-400 cursor-not-allowed"
        aria-disabled
      >
        {Icon && <Icon size={16} className="shrink-0" />}
        <span className="flex-1 truncate">{item.label}</span>
        <span className="inline-flex items-center gap-0.5 text-[10px] font-medium bg-gray-100 text-gray-500 px-1.5 py-0.5 rounded-full shrink-0">
          <Sparkles size={9} />
          Sắp
        </span>
      </div>
    );
  }

  return (
    <NavLink
      to={item.to}
      end={item.id === "overview"}
      onClick={onNavigate}
      className={({ isActive }) =>
        cn(
          "relative flex items-center gap-2.5 px-3 py-2 rounded-md text-sm transition-colors",
          isActive
            ? "bg-blue-50 text-blue-700 font-medium"
            : "text-gray-700 hover:bg-gray-50",
        )
      }
    >
      {({ isActive }) => (
        <>
          {isActive && (
            <span className="absolute left-0 top-1.5 bottom-1.5 w-0.5 bg-blue-600 rounded-r" />
          )}
          {Icon && (
            <Icon
              size={16}
              className={cn(
                "shrink-0",
                isActive ? "text-blue-600" : "text-gray-500",
              )}
            />
          )}
          <span className="flex-1 truncate">{item.label}</span>
        </>
      )}
    </NavLink>
  );
};

const GroupBlock = ({ group, onNavigate }) => {
  const items = getItemsInGroup(group.id);
  if (items.length === 0) return null;
  return (
    <div className="mt-3">
      <div className="text-[11px] uppercase tracking-wider font-semibold text-gray-400 px-3 pt-2 pb-1">
        {group.label}
      </div>
      <div className="flex flex-col gap-0.5">
        {items.map((item) => (
          <Item key={item.id} item={item} onNavigate={onNavigate} />
        ))}
      </div>
    </div>
  );
};

/**
 * Left sidebar for /reports/*.
 * - Top-level "Tổng quan" entry at the top
 * - Grouped sections below (Hoạt động / Hiệu suất / Bán hàng)
 * - onNavigate: optional callback fired after clicking an item (used by mobile drawer to close itself)
 */
const ReportsSidebar = ({ onNavigate }) => (
  <aside className="w-60 shrink-0 bg-white border-r border-gray-200 h-full overflow-y-auto">
    <div className="px-3 py-4">
      {TOP_LEVEL_ITEM && (
        <Item item={TOP_LEVEL_ITEM} onNavigate={onNavigate} />
      )}
      {REPORT_GROUPS.map((group) => (
        <GroupBlock key={group.id} group={group} onNavigate={onNavigate} />
      ))}
    </div>
  </aside>
);

export default ReportsSidebar;
